"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useRemoveElementOnPageChange = function (_a) {
    var elementId = _a.elementId;
    react_1.useEffect(function () {
        window.onpopstate = function () {
            var element = document.getElementById(elementId);
            if (element) {
                element.remove();
            }
        };
    }, []);
};
exports.default = useRemoveElementOnPageChange;
